



























































import { Component, Vue } from "vue-property-decorator";
import Link from "@/model/link";
import Project from "@/model/project";

@Component
export default class Home extends Vue {
  private icons: Link[] = [
    new Link("mdi-twitter", "https://twitter.com/bjorndaniel"),
    new Link(
      "mdi-linkedin",
      "https://ph.linkedin.com/in/daniel-sandberg-0b869213"
    ),
    new Link("mdi-mastodon", "https://dotnet.social/@bjorndaniel"),
    new Link("mdi-butterfly", "https://bsky.app/profile/bjorndaniel.bsky.social"),
    new Link("mdi-github", "https://github.com/bjorndaniel"),
    new Link("mdi-email", "mailto:info@bjorndaniel.se")
  ];

  private projects: Project[] = [
    // new Project(
    //   "Wordle clone wars",
    //   "https://wordle-clone-wars.bjorndaniel.se",
    //   "A site where you can upload your results for Wordle and a bunch of its clones and compare yourself to others"
    // ),
    new Project(
      "Love music",
      "https://lovemusic.bjorndaniel.se",
      "Love music can fetch playlists for a last.fm user and create Spotify playlists for them."
    ),
    new Project(
      "Blazor Invaders",
      "https://blazorinvaders.bjorndaniel.se",
      "A Blazor version of the classic Space Invaders game"
    ),
    new Project(
      "Blazor Lights Out",
      "https://lightsoutpuzzleblazor.azurewebsites.net/",
      "A Blazor version of a 'Lighs out' style game"
    ),
    new Project(
      "Blazorships",
      "https://blazorships.azurewebsites.net",
      "A serverless implementation of the classic Battleships game"
    ),
    new Project(
      "Db anonymizer",
      "https://anonymizer.bjorndaniel.se",
      "An application to remove sensitive user information from a database and replace it with dummy data"
    ),
    new Project(
      "Wordle Clone Wars",
      "https://wordlewars-web-3fu3rk3yykzne.azurewebsites.net/",
      "Battle your friends in Wordle and its clones."
    ),
    new Project(
      "My nuget packages",
      "https://www.nuget.org/profiles/bjorndaniel",
      "All nugets I have created so far"
    ),
    new Project(
      "My Visual Studio extensions",
      "https://marketplace.visualstudio.com/search?term=BdSoftware&target=VS&category=All%20categories&vsVersion=&sortBy=Relevance",
      "All extensions I have created for Visual Studio"
    ),
    new Project(
      "My Visual Studio Code extensions",
      "https://marketplace.visualstudio.com/search?term=BdSoftware&target=VSCode&category=All%20categories&sortBy=Relevance",
      "All extensions I have created for Visual Studio Code"
    )
  ];
}
